(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('ProfileManagementController', ProfileManagementController);

    /* @ngInject */
    function ProfileManagementController(userProfileService, userOrganizationService, currentUser, dialogService) {
        var vm = this;
        vm.$onInit = onInit;

        vm.loading = true;
        vm.isValid = false;
        vm.model = null;
        vm.existingProfile = null;

        vm.save = save;
        vm.updateOrganization = updateOrganization;
        vm.onFormValidationChange = onFormValidationChange;
        vm.onAddressChange = onAddressChange;

        function onInit() {
            userProfileService.getUserProfile().then(function (result) {
                vm.loading = false;

                if (result.status === 200) {
                    vm.model = {
                        UserId: result.data.UserId,
                        FirstName: result.data.FirstName,
                        LastName: result.data.LastName,
                        Email: result.data.Email,
                        PhoneNumber: result.data.PhoneNumber,
                        LocationRoleId: result.data.LocationRoleId,
                        DepartmentRoleId: result.data.DepartmentRoleId,
                        TitleRoleId: result.data.TitleRoleId,
                        Organization: result.data.Organization || {}
                    };
                    vm.model.Organization.CustomerId = null;                    
                }
            });
        }

        function save() {
            userProfileService.updateProfileInformation(vm.model).then(function (result) {
                var title = result.status === 200 ? 'Update Successful' : 'Update Failed';
                var message = result.status === 200 ? 'Successfully updated your profile information' :
                    'An error occured while updating your profile information.' +
                    'Please try again or contact an administrator.';

                dialogService.info(title, message);
            });
        }

        function updateOrganization() {
            var model = mapPendingAddressModel(vm.model.Organization);

            dialogService.confirm('Organization Update',
                'You are attempting to update your organization name or address.' +
                'This process is not automatic and could take a few days.Are you sure you want to proceed? ')
                .then(function () {
                    userOrganizationService.updateOrganizationDetails(vm.model.UserId, model).then(function (result) {

                        var title = result.status === 200 ? 'Update Successful' : 'Update Failed';
                        var message = result.status === 200 ?
                            'Request to update your organization details has been successfully sent.' :
                            'An error occured while requesting to update your organization details. ' +
                            'Please try again or contact an administrator.';

                        dialogService.info(title, message);
                    });
                });
        }

        function mapPendingAddressModel(address) {
            return {
                MatchedCustomerId: address.CustomerId,
                CustomerName: address.Name,
                OrigAddress: address.Address1,
                OrigAddress2: address.Address2,
                OrigCity: address.City,
                OrigZip: address.ZipCode,
                OrigCountry: address.CountryCode,
                OrigPhone: '',
                OrigFax: ''
            };
        }

        function onFormValidationChange(isValid) {
            vm.isValid = isValid;
        }

        function onAddressChange(address) {
            if (address) {
                vm.model.Organization = angular.extend(vm.model.Organization, address);
            }

        }
    }

})();
